import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi } from './getApi';

export const apiPayMemmory = async (
  userId: string,
  purchaseId: string,
  payCena: number
) => {
  const params: IApiParams = {
    url: `api/payMemmory.php?uid=${userId}&pid=${purchaseId}&price=${payCena}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
